import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEYS = { vendor: "tl_vendor_token", customer: "tl_customer_token", admin: "tl_admin_token" } as const;
export type Kind = keyof typeof TOKEN_KEYS;

const VENDOR_PREFIXES = ["/vendor", "/billing", "/payments/checkout"];

export const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const kind: Kind = url.startsWith("/admin") ? "admin" : VENDOR_PREFIXES.some((p) => url.startsWith(p)) ? "vendor" : "customer";
  const token = localStorage.getItem(TOKEN_KEYS[kind]);
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e: any): string {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
}

export const fileUrl = (path?: string | null) => (path ? `${API_BASE}/api/files/${path}` : null);
export const boothUrl = (slug: string, src = "qr") => `${window.location.origin}/t/${slug}${src === "nfc" ? "?src=nfc" : ""}`;

export const STAGES = [
  { key: "new", label: "New", color: "#3B82F6" },
  { key: "contacted", label: "Contacted", color: "#8B5CF6" },
  { key: "qualified", label: "Qualified", color: "#F59E0B" },
  { key: "quoted", label: "Quoted", color: "#06B6D4" },
  { key: "won", label: "Booked / Won", color: "#10B981" },
  { key: "lost", label: "Closed Lost", color: "#EF4444" },
];
export const stageOf = (key: string) => STAGES.find((s) => s.key === key) || STAGES[0];

export const timeAgo = (iso: string) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
